<template>
  <div>
    <ContentHeader :order-nav="true" :show-back="false" />

    <div class="content-container" v-loading="listLoading">
      <QueryPanel order-type="shopSign" @search="searchOrder" />

      <div class="order-list" v-if="orderList.length">
        <OrderLine @reload="queryOrderList" v-for="order in orderList" :key="order.orderId" :order-info="order" :order-type="'shopSign'"/>
      </div>
      <div class="pag-row" v-if="orderList.length">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :current-page="queryParam.page"
          :page-size="queryParam.pageSize"
          :total="total"
          @current-change="handleCurrentChange"
        />
      </div>

      <div v-else class="no-data">
        暂无数据
      </div>
    </div>
  </div>
</template>

<script>
import ContentHeader from '@/components/content-header'
import QueryPanel from './components/query-panel'
import OrderLine from './components/order-line'
export default {
  name: 'order-list-shop-sign',
  components: {
    ContentHeader,
    QueryPanel,
    OrderLine
  },
  data () {
    return {
      total: null,
      listLoading: false,
      queryParam: {
        page: 1,
        pageSize: 10,
        orderNumber: '',
        subOrderNumber: '',
        itemName: '',
        orderStatus: '',
        orderDateFrom: '',
        orderDateTo: '',
        orderTypes: '',
        keyword: '',
        tradeApplyNumber: '',
        pocName: '',
        supplierName: ''
      },
      orderList: []
    }
  },
  created () {
    this.queryOrderList()
  },
  methods: {
    searchOrder (param) {
      this.queryParam.page = 1
      this.queryParam.orderNumber = param.orderNumber
      this.queryParam.subOrderNumber = param.subOrderNumber
      this.queryParam.itemName = param.itemName
      this.queryParam.orderStatus = param.orderStatus
      this.queryParam.orderDateFrom = param.orderDateFrom
      this.queryParam.orderDateTo = param.orderDateTo
      this.queryParam.keyword = param.keyword
      this.queryParam.tradeApplyNumber = param.tradeApplyNumber
      this.queryParam.pocName = param.pocName
      this.queryParam.supplierName = param.supplierName
      this.queryOrderList()
    },
    queryOrderList () {
      this.queryParam.orderTypes = '09'
      this.listLoading = true
      this.$store.dispatch('queryOrderList', this.queryParam).then(res => {
        this.listLoading = false
        if (res.data.resultCode === '0') {
          this.orderList = res.data.resultData.purchaseOrderList || []
          this.total = res.data.resultData.pageInfo.totalCounts
          this.setOrderType()
        }
      }).catch(() => {
        this.listLoading = false
      })
    },
    setOrderType () {
      if (this.orderList.length) {
        this.orderList.forEach(order => {
          let orderType = 'shopSign'
          this.$set(order, 'orderTypeName', orderType)
          if (order.subOrderList && order.subOrderList.length > 0) {
            order.subOrderList.map(item => {
              this.$set(item, 'orderTypeName', orderType)
            })
          }
        })
      }
    },
    handleCurrentChange (val) {
      this.queryParam.page = val
      this.queryOrderList()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
